import store from '../store/store';

export function auth({ to, from, next }) {
  if (!store.getters['auth/authenticated']) {
    return next({
      name: 'Login',
      params: { program: to.params.program },
    });
  }

  if (store.getters['auth/getOrderQuery'] !== null) {
    return next({
      name: 'Order',
      params: { program: to.params.program },
    });
  } else {
    return next();
  }
}

export function registeredAccount({ to, from, next }) {
  if (!store.getters['auth/authenticated']) {
    return next({
      name: 'Login',
      params: { program: to.params.program },
    });
  }

  if (
    store.getters['auth/isTestAccountRegistered'] ||
    store.getters['auth/isTestAccountunRegistered']
  ) {
    return next({
      name: 'Licence',
      params: { program: to.params.program },
    });
  }

  return next();
}
